/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Cancel_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your plan will revert to Free at the end of your billing period. No refund for the remaining period." |
*
* @param {Sub_Cancel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_description = /** @type {((inputs?: Sub_Cancel_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Tarif wird am Ende des Abrechnungszeitraums auf Free zurückgesetzt. Keine Erstattung für den verbleibenden Zeitraum.")
	return /** @type {LocalizedString} */ ("Your plan will revert to Free at the end of your billing period. No refund for the remaining period.")
});